import { render } from "./UserDetailPost.vue?vue&type=template&id=5b55f0af&scoped=true"
import script from "./UserDetailPost.vue?vue&type=script&lang=js"
export * from "./UserDetailPost.vue?vue&type=script&lang=js"

import "./UserDetailPost.vue?vue&type=style&index=0&id=5b55f0af&scoped=true&lang=css"

import exportComponent from "../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b55f0af"]])

export default __exports__